import { Flex } from "@chakra-ui/react"
import { FormattedMessage } from "react-intl"

import { ButtonWithIcon } from "@/components/Buttons/ButtonWithIcon"
import { UserLogoutIcon } from "@/components/Icons"
import { P3 } from "@/components/Typographies"
import { useAuthenticatedUserContext } from "@/context/AuthenticatedUserContext/AuthenticatedUserContext"
import { getDisplayedName } from "@/domain/user/getDisplayedName"
import { useExitImpersonation } from "@/hooks/useExitImpersonation"

export const ImpersonationBanner = () => {
  const { user } = useAuthenticatedUserContext()
  const { exit, isLoading } = useExitImpersonation()

  if (user?.isImpersonating !== true) {
    return null
  }

  const name = getDisplayedName(user.firstname, user.lastname)
  const email = user.username

  return (
    <Flex
      align="center"
      justify="end"
      gap={4}
      px={4}
      py={2}
      bg="surfaceInverseAlt"
      color="textInverse"
      flexShrink={0}
    >
      <P3>
        <FormattedMessage id="impersonation.banner.message" values={{ name, email }} />
      </P3>
      <ButtonWithIcon
        icon={UserLogoutIcon}
        iconColor="text"
        variant="solid"
        bg="surfaceGreige"
        color="text"
        flexShrink={0}
        isLoading={isLoading}
        _hover={{ bg: "surfaceAlt" }}
        onClick={() => void exit()}
        size="sm"
      >
        <FormattedMessage id="impersonation.banner.stop" />
      </ButtonWithIcon>
    </Flex>
  )
}
